export default __webpack_public_path__ + "static/media/screen-desktop-active.1c26f9bd.svg";